module.exports = __webpack_public_path__ + "static/The-Evolution-of-Refrigerators-From-Cooling-to-Intelligent-Food-63fa43e2590af55b9a832f21ffe8ce43.png";